module.exports = __webpack_public_path__ + "static/media/second_oeuvre.bd50fdae.png";